import { Random } from './Random';
export function isLinkRandom(link) {
    return link !== null && typeof link === 'object' && link instanceof Random;
}
export {
    isLinkRandom as isRandom
};
export default isLinkRandom;    //# sourceMappingURL=isRandom.js.map
